import React from "react";
import { Logo } from "./Logo";
const links = ["Privacy policy", "Terms of service", "Refund policy", "Contact"];
export function Footer() {
  return <footer className="border-t border-neutral-200 bg-white px-4 py-10" data-id="element-74" data-mp="3ggk7utmc79z0">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-6" data-id="element-75" data-mp="32p5naics70pu">
        <Logo small data-id="element-76" data-mp="36oxwmxa01aw9" />
        <nav aria-label="Legal links" className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-ink-muted" data-id="element-77" data-mp="36q93j5yqqyrl">
          {links.map(l => <a key={l} href="#" className="hover:text-brand" data-id="element-78" data-mp="3ucxsgbm63rhp">{l}</a>)}
        </nav>
        <p className="text-xs text-ink-muted" data-id="element-79" data-mp="37xyao5wgelp">© 2026 WoodForge DIY. All rights reserved.</p>
      </div>
    </footer>;
}